import * as React from "react";

const CENTaxonomyTwoLineMenu: React.FC = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 9C1.44687 9 1 9.44688 1 10C1 10.5531 1.44687 11 2 11H14C14.5531 11 15 10.5531 15 10C15 9.44688 14.5531 9 14 9H2ZM2 5C1.44687 5 1 5.44687 1 6C1 6.55313 1.44687 7 2 7H14C14.5531 7 15 6.55313 15 6C15 5.44687 14.5531 5 14 5H2Z"
                fill="#262525"
            />
        </svg>
    );
};

export default React.memo(CENTaxonomyTwoLineMenu);
